/*************************************************/
/* NEWS                                          */
/*************************************************/

export function collapsedText() {
    const collapsedTextClass = "collapsed-text--collapsed";
    const collapsedTextButtonSelector = ".collapsed-text__button";

    const init = function () {
        var collapsedTextButtons = document.querySelectorAll(collapsedTextButtonSelector);
        if (collapsedTextButtons.length > 0) {
            collapsedTextButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const collapsedTextField = e.target.previousElementSibling;
                    if(collapsedTextField) {
                        collapsedTextField.style.height = collapsedTextField.scrollHeight + 'px';
                        collapsedTextField.classList.remove(collapsedTextClass);
                         e.target.remove();
                    }
                });
            });
        }
    };


    init();
}
